import { motion } from "framer-motion";
import { type ReactNode } from "react";
import { Card } from "../../../components/ui/Card";

interface CTAProps {
  renderButton: (
    to: string,
    children: ReactNode,
    variant?: "primary" | "secondary" | "ghost",
  ) => JSX.Element;
}

export function CTA({ renderButton }: CTAProps) {
  return (
    <section className="relative py-32">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Card variant="hover" className="p-12 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="aurora-gradient">Open Source AI Code Review</h2>
            <p className="mt-6 text-lg text-white/70 max-w-2xl mx-auto">
              Join the community of developers shipping better quality code
              through AI-assisted reviews. Free forever for open source projects.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
              {renderButton("/login", "Start Free")}
              {renderButton(
                "https://github.com/AiCodeReview/ACRBase",
                "View on GitHub",
                "secondary",
              )}
            </div>
            <p className="mt-6 text-white/60 mx-auto">
              Free for Basics • Premium Features & Customization Available for Enterprise
            </p>
          </motion.div>
        </Card>
      </div>
    </section>
  );
}
